import { h, Component } from "preact";
import { connect } from "preact-redux";
import PropTypes from "prop-types";

import { Loader } from "semantic-ui-react";
import styles from "./LoginPage.scss";
import { DeviceGoogleLogin } from "../components/deviceGoogleLogin";

export class LoginPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { loading, error } = this.props;
    return (
      <div className={styles.container}>
        {error && <div style={{ color: "red" }}>{error}</div>}
        {loading ? (
          <div>
            <Loader active indeterminate>
              Logging in
            </Loader>
          </div>
        ) : (
          <div>
            <div className={styles.item}>
              <h1>Happiness Meter</h1>
            </div>
            <div className={styles.item}>
              <DeviceGoogleLogin />
            </div>
          </div>
        )}
      </div>
    );
  }
}

LoginPage.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  loading: state.login.loginLoading,
  error: state.login.loginError,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage);



// WEBPACK FOOTER //
// ./src/modules/login/pages/LoginPage.js